module.exports = __webpack_public_path__ + "assets/1.a18451e3.png";